import * as companyApi from '@/api/companyApi.js';
import { useUserStore } from '@/stores/userStore'

export default {
    namespaced: true,
    state() {
        return {
            companyListDat: [],
            companyInfo: null,
        }
    },
    getters: {
        getList(state) {
            return state.companyListDat
        },
        getInfo(state) {
            return state.companyInfo
        }
    },
    mutations: {
        setList(state, listData) {
            state.companyListDat = JSON.parse(listData)
        },
        setInfo(state, listData) {
            state.companyInfo = JSON.parse(listData)
        },
        clearInfo(state) {
            state.companyInfo = null
        },
    },
    actions: {
        async list({ commit }) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await companyApi.listCompany(token)

            if (dataResp) {
                commit('setList', JSON.stringify(dataResp))
            }
        },
        async info({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await companyApi.getCompany(token, id)

            if (dataResp) {
                commit('setInfo', JSON.stringify(dataResp))
            }
        },
        async delete({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await companyApi.delCompany(token, id)

            if (dataResp) {
                commit('clearInfo')
            }
        },
        async addCompany({ commit }, data) {
            // console.log(data);
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await companyApi.updateCompany(token, data)

            if (dataResp) {
                commit('clearInfo')
            }
        },
        async inviteCode({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await companyApi.inviteCode(token, data)
            return dataResp
        },
        async sendInvitation({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await companyApi.sendInvitation(token, data)
            return dataResp
        },        
    }
}